export const firebaseConfig = {
    apiKey: "AIzaSyDE3CROY7adBfQBwmKJQHs7E_cMKoxzPoo",
    authDomain: "spifi-macs.firebaseapp.com",
    databaseURL: "https://spifi-macs.firebaseio.com",
    projectId: "spifi-macs",
    storageBucket: "spifi-macs.appspot.com",
    messagingSenderId: "417016449773",
    appId: "1:417016449773:web:65ee6dd887427dea1b1ae4"
};